import React, { useRef } from 'react';
import DeleteRedIcon from "../../assets/delete_red.svg";
import ReplyIcon from "../../assets/reply.svg";
import { useOnClickOutside } from "../../hooks/useOutsideClick";

interface ContextMenuProps {
    show: boolean,
    isAllowDeleteOption: boolean,
    x: number,
    y: number,
    openRemoveModal: () => void
    onClose: () => void
    onReply: () => void
}

export const MessageContextMenu = ({ show, isAllowDeleteOption, openRemoveModal, x, y, onClose, onReply }: ContextMenuProps) => {
    // Контекстное меню для сообщения в чате
    const contextMenuRef = useRef(null);
    useOnClickOutside(contextMenuRef, onClose);

    if (!show) return null

    return (
        <div
            ref={contextMenuRef}
            className='absolute flex overflow-hidden justify-center z-10 bg-white rounded-lg shadow-below p-3'
            style={{
                left: x,
                top: y,
            }}
        >
            <div className='flex flex-col gap-1 min-w-32'>
                <button
                    onClick={onReply}
                    className="w-full p-2 flex flex-row items-center gap-1"
                >
                    <img src={ReplyIcon} alt="" />
                    Ответить
                </button>
                {isAllowDeleteOption &&
                    <button
                        onClick={openRemoveModal}
                        className="w-full p-2 flex flex-row text-red-500 items-center"
                    >
                        <img src={DeleteRedIcon} alt="" />
                        Удалить сообщение
                    </button>
                }
            </div>
        </div>
    );
};